import classNames from 'classnames'
import {VmButton, VmIcons, VmInput, VmView} from 'components'
import {LuCalendarPlus, LuCalendarClock} from 'react-icons/lu'
import {FaDiagnoses} from 'react-icons/fa'
import {VscReferences} from 'react-icons/vsc'
import {FaTransgender} from 'react-icons/fa'
import {useEffect, useState} from 'react'

const defaultData = {
  // No Kunjungan
  noKunjungan: 'G1',
  // Nama Peserta
  nama: 'Pcare',
  // No Kartu
  noKartu: '0002079280574',
  // Tanggal Pelayanan
  tglPelayanan: 'Tanggal Pelayanan',
  // Tanggal Entri
  tglEntri: 'Tanggal Entri',
  // Jenis Kelamin
  jk: 'Jenis Kelamin',
  // Diagnosa
  diagnosa: 'Diagnosa',
  // Dirujuk
  dirujuk: 'Dirujuk',
}
export default function CardItem({
  label = '',
  data = defaultData,
  index = 0,
  onDelete = () => {},
}) {
  const [
      {
        noKunjungan = '',
        noKartu = '',
        nama = '',
        tglPelayanan = '',
        tglEntri = '',
        jk = '',
        diagnosa = '',
        dirujuk = '',
        showdelete = true,
      },
      setdata,
    ] = useState(data),
    classPM =
      'relative flex justify-center items-center rounded bg-white overflow-hidden border-[0.5px] min-w-[1.25rem] h-5 p-[1px]',
    classHTitle =
      'text-prevent-select text-xs font-medium text-gray2-payment mb-1',
    classCSect = 'relative flex flex-row justify-between p-4'

  useEffect(() => {
    setdata(data)
  }, [data])

  return (
    <VmView className="relative flex flex-col overflow-hidden !text-black2-payment bg-gray7-payment mb-4 last:mb-20 rounded-xl rounded-t-2xl gap-1">
      {/* Head */}
      <VmView className="relative flex flex-wrap bg-white text-prevent-select">
        {/* Right Header */}
        <VmView className="flex flex-col px-4 py-3 mr-auto">
          {/* noKunjungan */}
          <VmView className="pb-1 font-semibold">{noKunjungan}</VmView>
          {/* Nama */}
          <VmView className="flex flex-wrap text-sm">{nama}</VmView>
          {/* Nama */}
          <VmView className="flex flex-wrap text-sm">{noKartu}</VmView>
        </VmView>
        {/* Left Header */}
        <VmView className="text-sm p-1">
          {/* showdelete */}
          {showdelete && (
            <VmView
              label={`delete-item${label}-##-${index}-##-${noKunjungan}`}
              className="flex justify-center items-center text-red-600 rounded-lg w-8 h-8 p-[1px]"
              onClick={() => onDelete(data)}
            >
              <VmIcons
                onClick={() => onDelete(data)}
                label={`delete-item${label}-##-${index}-##-${noKunjungan}`}
                name="VmTrashIcon"
                variant="outline"
                size={20}
              />
            </VmView>
          )}
        </VmView>
      </VmView>
      {/* Footer */}
      <VmView className="relative flex flex-wrap bg-white text-prevent-select">
        <VmView className="flex flex-col p-4 w-fill-available text-sm">
          <VmView className="grid grid-cols-2 gap-4">
            {/* Tanggal Pelayanan */}
            <VmView className="flex mr-auto gap-2">
              <VmView className="flex items-center w-7 h-7 pt-1">
                <LuCalendarClock size={25} />
              </VmView>
              <VmView className="flex flex-col mr-auto">
                <VmView className="text-sm">{'Pelayanan'}</VmView>
                <VmView className="font-bold break-all">{tglPelayanan}</VmView>
              </VmView>
            </VmView>
            {/* Tanggal Entri */}
            <VmView className="flex mr-auto gap-2">
              <VmView className="flex items-center w-7 h-7 pt-1">
                <LuCalendarPlus size={25} />
              </VmView>
              <VmView className="flex flex-col mr-auto">
                <VmView className="text-sm">{'Entri'}</VmView>
                <VmView className="font-bold break-all">{tglEntri}</VmView>
              </VmView>
            </VmView>
          </VmView>
          {/* Jenis Kelamin */}
          <VmView className="flex mr-auto gap-2">
            <VmView className="flex items-center w-7 h-7 pt-1">
              <FaTransgender size={25} />
            </VmView>
            <VmView className="flex flex-col mr-auto">
              <VmView className="text-sm">{'Jenis Kelamin'}</VmView>
              <VmView className="font-bold break-all">
                {jk?.length > 0 ? jk : '-'}
              </VmView>
            </VmView>
          </VmView>
          {/* Diagnosa */}
          <VmView className="flex mr-auto gap-2">
            <VmView className="flex items-center w-7 h-7 pt-1">
              <FaDiagnoses size={25} />
            </VmView>
            <VmView className="flex flex-col mr-auto">
              <VmView className="text-sm">{'Diagnosa'}</VmView>
              <VmView className="font-bold break-all">
                {diagnosa?.length > 0 ? diagnosa : '-'}
              </VmView>
            </VmView>
          </VmView>
          {/* Dirujuk */}
          <VmView className="flex mr-auto gap-2">
            <VmView className="flex items-center w-7 h-7 pt-1">
              <VscReferences size={25} />
            </VmView>
            <VmView className="flex flex-col mr-auto">
              <VmView className="text-sm">{'Dirujuk'}</VmView>
              <VmView className="font-bold break-all">
                {dirujuk?.length > 0 ? dirujuk : 'TIDAK'}
              </VmView>
            </VmView>
          </VmView>
        </VmView>
      </VmView>
    </VmView>
  )
}
